import React, { useEffect, useState } from "react";
import { Badge, Image, Layout, Menu } from "antd";
import { Images } from "../ImageController/Index";
import { LogoutMenuItem, MenuItems } from "./MenuItems";
import { useNavigate } from "react-router-dom";
import logout from "../Assets/logout.png";
const { Header, Sider, Content } = Layout;
const ProjectLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [windowwidth, setwindowwidth] = useState(window.innerWidth);
  const [showDefault, setShowDefault] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setwindowwidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (windowwidth > 1000) {
      setCollapsed(false);
      setShowDefault(true);
    } else {
      setCollapsed(true);
      setShowDefault(false);
    }
  }, [windowwidth]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const logoutMenu = LogoutMenuItem();
  const menuItems = MenuItems();

  return (
    <>
      <Layout hasSider className="min-h-screen sidebar">
        <Sider
          style={{
            position: "fixed",
            marginBottom: "20px",
            overflowY: "scroll",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
          }}
          trigger={null}
          collapsible
          className=""
          collapsed={collapsed}
        >
          <div className="demo-logo-vertical flex justify-around items-center my-5">
            {!collapsed ? (
              <>
                <div className="flex gap-4 justify-start items-center">
                  <img
                    src={Images.FullLogo}
                    className=" w-[75%] ml-5"
                    alt="Weblogo"
                  />
                </div>
              </>
            ) : (
              <img 
              src={Images.Logo} 
              // alt="WeblogoSmall" className="h-8 w-8" />
              alt="WeblogoSmall" className="h-6 w-10" />
            )}
          </div>

          <div className=" sm:h-full">
            <Menu theme="dark" mode="inline" items={menuItems} />
          </div>

          {/* Logout Menu Item at the Bottom */}

          <>
            {" "}
            {!collapsed ? (
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  width: "100%",
                  marginTop: "10px",
                }}
              >
                <Menu theme="dark" mode="inline" items={logoutMenu} />
              </div>
            ) : (
              <div className="flex justify-center items-center border-t-2 p-2 cursor-pointer">
                <Image
                  onClick={handleLogout}
                  preview={false}
                  src={logout}
                  width={25}
                  height={25}
                  title="Sign Out"
                />
              </div>
            )}
          </>
        </Sider>

        <Layout>
          <Content
            className={`bg-white h-full p-5 md:p-8
                 ${collapsed ? "ml-[35px]" : "ml-[200px] overflow-hidden"}
            `}
          >
            {/* <div className="mb-5 w-full flex justify-between items-center gap-4">
              <BsArrowLeft
                size={20}
                onClick={() => navigate(-1)}
                className="cursor-pointer"
              />
            </div> */}

            {children}
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default ProjectLayout;
